import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { CandidateReviewPayload } from "../../types/candidate";

import { GO_HIRE_QUERY_KEYS } from "../queryKeys";
import { reviewCandidate } from "../services/candidate.services";
import { ReviewCandidateResponse } from "../types/candidate.types";

interface UseReviewCandidateParams {
  jobId: number | string;
  candidateId: number | string;
}

export const useReviewCandidate = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal" });

  return useMutation<ReviewCandidateResponse, Error, UseReviewCandidateParams & { payload: CandidateReviewPayload }>({
    mutationFn: ({ jobId, candidateId, payload }) => reviewCandidate({ jobId, candidateId, payload }),
    onSuccess: (_, { jobId, candidateId }) => {
      // Invalidate relevant queries
      queryClient.invalidateQueries({ queryKey: GO_HIRE_QUERY_KEYS.candidates(String(jobId)) });
      queryClient.invalidateQueries({ queryKey: GO_HIRE_QUERY_KEYS.jobDetails(String(jobId)) });
      queryClient.invalidateQueries({ queryKey: GO_HIRE_QUERY_KEYS.topMatchedApplicants(String(jobId)) });

      queryClient.invalidateQueries({ queryKey: GO_HIRE_QUERY_KEYS.candidateApplication(jobId, candidateId) });

      toast.success(t("candidateReviewedSuccessfully"));
    },
  });
};
